export const clearInputs = (obj) => {
    for (let i of Object.keys(obj)) {
        let id = i + 'p'
        document.getElementById(id).innerText = ''
    }
}